@if (success) {
  <h1>{{ 'MEETINGS.HANG_UP.REQUEST_RECEIVED' | translate }}</h1>
}
